<template>
  <div class="legend">
    <div class="legend-title is-italic has-text-weight-bold has-text-grey-light">
      Legend
    </div>
    <div class="legend-content is-flex">
      <div v-if="eligibility" class="indicator-type is-flex">
        <div class="indicator-title is-flex has-text-weight-bold has-text-grey">
          Eligibility Indicator
        </div>
        <div class="indicator-values is-flex">
          <div class="indicator-value is-flex">
            <div class="indicator-icon">
              <es-match/>
            </div>
            <div class="indicator-summary is-flex-block">
              <div class="is-flex">
                Eligible
              </div>
              <div class="no-wrap is-flex">
                (ISP &ge; {{ eligibilityHighestPoint }})
              </div>
            </div>
          </div>
          <div class="indicator-value is-flex">
            <div class="indicator-icon is-flex">
              <es-near-match/>
            </div>
            <div class="indicator-summary is-flex-block">
              <div class="is-flex">
                Near Eligible
              </div>
              <div class="no-wrap is-flex">
                ({{ eligibilityLowestPoint }} &le; ISP &lt; {{ eligibilityHighestPoint }})
              </div>
            </div>
          </div>
          <div class="indicator-value is-flex">
            <div class="indicator-icon is-flex">
              <es-not-eligable/>
            </div>
            <div class="indicator-summary is-flex-block">
              <div class="is-flex">
                Not Eligible
              </div>
              <div class="no-wrap is-flex">
                (ISP &lt; {{ eligibilityLowestPoint }})
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="trend" class="indicator-type is-flex">
        <div class="indicator-title is-flex has-text-weight-bold has-text-grey">
          Trend Indicator
        </div>
        <div class="indicator-values is-flex">
          <div class="indicator-value is-flex">
            <div class="indicator-icon is-flex">
              <isp-positive/>
            </div>
            <div class="indicator-summary is-flex">
              <div class="indicator-name no-wrap is-flex">
                Current Year ISP Goes Up
              </div>
            </div>
          </div>
          <div class="indicator-value is-flex">
            <div class="indicator-icon is-flex">
              <isp-negative/>
            </div>
            <div class="indicator-summary is-flex">
              <div class="indicator-name no-wrap is-flex">
                Current Year ISP Goes Down
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="matchType" class="indicator-type is-flex">
        <div class="indicator-title is-flex has-text-weight-bold has-text-grey">
          Match Type Indicator
        </div>
        <div class="indicator-values is-flex">
          <div class="indicator-value is-flex">
            <div class="indicator-icon is-flex">
              <manual-match-indicator/>
            </div>
            <div class="indicator-summary is-flex">
              <div class="indicator-name no-wrap is-flex">
                Manual Match
              </div>
            </div>
          </div>
          <div class="indicator-value is-flex">
            <div class="indicator-icon is-flex">
              <system-match-indicator/>
            </div>
            <div class="indicator-summary is-flex">
              <div class="indicator-name no-wrap is-flex">
                System Match
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EsMatch from '@/components/EsMatch.vue';
import EsNearMatch from '@/components/EsNearMatch.vue';
import EsNotEligable from '@/components/EsNotEligable.vue';
import IspNegative from '@/components/IspNegative.vue';
import IspPositive from '@/components/IspPositive.vue';
import ManualMatchIndicator from '@/components/ManualMatchIndicator.vue';
import SystemMatchIndicator from '@/components/SystemMatchIndicator.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    EsMatch,
    EsNearMatch,
    EsNotEligable,
    IspNegative,
    IspPositive,
    ManualMatchIndicator,
    SystemMatchIndicator,
  },
  props: {
    eligibility: {
      type: Boolean,
      default: true,
    },
    trend: {
      type: Boolean,
      default: true,
    },
    matchType: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters('propertiesModule', [
      'properties',
    ]),
    eligibilityHighestPoint() {
      if (!this.properties['CEP-ISP_PERCENT']) {
        return '';
      }
      return `${this.properties['CEP-ISP_PERCENT'] * 100}%`;
    },
    eligibilityLowestPoint() {
      if (!this.properties['CEP-GRACE_YEAR_PERCENT']) {
        return '';
      }
      return `${this.properties['CEP-GRACE_YEAR_PERCENT'] * 100}%`;
    },
  },
};
</script>

<style lang="sass" scoped>
  .legend
    background-color: #f9f9f9
    padding: 0rem 1rem
    box-shadow: #AAA 0px 1px 3px
    font-size: 12px
    // min-height: 200px
  .legend-title
    padding: .25rem 0rem
    border-bottom: 1px solid #EEE
  .legend-content
    padding: 1rem 0rem
    margin-left: -1rem
    flex-wrap: wrap
    // min-height: 100px
  .indicator-type
    min-width: 200px
    flex-direction: column
    border-right: 1px solid #EEE
    padding-left: 1rem
  .indicator-title
    padding: .25rem 0rem
  .indicator-values
    height: 100%
    padding: .5rem 2rem .5rem 0rem
  .indicator-value
    min-width: 100px
    padding-right: 2rem
  .indicator-icon
    padding-right: 1rem
    align-items: center
  .indicator-summary
    justify-content: center
  .indicator-name
    align-items: center
  .no-wrap
    white-space: nowrap
</style>
